import NoSleep from "nosleep.js";
import { useEffect, useRef, useState } from "react";

export default function useNoSleep() {
  const [noSleep, setNoSleep] = useState<NoSleep>();

  useEffect(() => {
    if (noSleep) {
      return;
    }

    setNoSleep(new NoSleep());
  }, [noSleep]);

  return noSleep;
}
